import { ApplicationState } from "core/redux/store";

const rootSelector = (state: ApplicationState) => state.randomScramble;

export const randomScrambleSelector = (state: ApplicationState): string =>
  rootSelector(state).scramble;
